import React from 'react'
import './Home.css'
import { Input, Icon, Button, Form, DatePicker } from 'antd'
import { NavLink, Switch, Route, Redirect } from 'react-router-dom'
import Instructions from '../component/instructions'
import Login from '../component/login'
import PersonAppointment from '../PersonAppointment/PersonAppointment'
import ShowAppointment from '../ShowAppointment/ShowAppointment'
import ShowAppointmentFaild from '../ShowAppointmentFaild/ShowAppointmentFaild'
const FormItem = Form.Item
const { RangePicker } = DatePicker
// 日，月，年
const DateArray = [
  {
    label: '日',
    value: 'd'
  },
  {
    label: '月',
    value: 'm'
  },
  {
    label: '年',
    value: 'y'
  }
]
class Home extends React.Component {
  state = {
    selectRadio: 'd'
  }
  checkRadio(item) {
    // console.log(item)
    this.setState({
      selectRadio: item.value
    })
  }

  render() {
    return (
      <div className="home">
        <Switch>
        <Route path="/Main/Home/Login" component={Login}></Route>
          <Route path="/Main/Home/Instructions" component={Instructions}></Route>
          <Route path="/Main/Home/PersonAppointment" component={PersonAppointment}></Route>
          <Route path="/Main/Home/ShowAppointment" component={ShowAppointment}></Route>
          <Route path="/Main/Home/ShowAppointmentFaild" component={ShowAppointmentFaild}></Route>
          <Redirect
            from="/Main/Home"
            to="/Main/Home/Login"
          ></Redirect>
        </Switch>
      </div>
    )
  }
}
export default Home
